import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const WEATHER_API_KEY = process.env.REACT_APP_FORECAST_API_KEY;

interface WeatherData {
  temp: number;
  condition: string;
  icon: string;
  city: string;
}

const DEFAULT_LOCATION = { lat: 42.6675, lon: 21.1662 };

export const WeatherWidget: React.FC = () => {
  const [weather, setWeather] = useState<WeatherData | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchWeather = async (lat: number, lon: number) => {
    try {
      const res = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=metric&appid=${WEATHER_API_KEY}`,
      );

      if (!res.ok) throw new Error("Weather API failed");

      const data = await res.json();

      setWeather({
        temp: data.main.temp,
        condition: data.weather[0].main,
        icon: `https://openweathermap.org/img/wn/${data.weather[0].icon}.png`,
        city: data.name,
      });
    } catch (err) {
      console.error("WeatherWidget error:", err);
      setWeather(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!navigator.geolocation) {
      fetchWeather(DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lon);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        fetchWeather(position.coords.latitude, position.coords.longitude);
      },
      () => {
        fetchWeather(DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lon);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000,
      },
    );
  }, []);

  if (loading) return <div>Loading weather…</div>;
  if (!weather) return <div>Weather unavailable</div>;

  return (
    <div
      onClick={() => navigate("/Moti")}
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 8px",
        color: "white",
      }}
    >
      <img src={weather.icon} alt={weather.condition} width={24} height={24} />
      <span>
        {weather.city}: {Math.round(weather.temp)}°C, {weather.condition}
      </span>
    </div>
  );
};
